import React, { useEffect, useState } from 'react';
import { Box, keyframes } from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';

interface RotateDeviceIndicatorProps {
    show?: boolean;
}

const rotateAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(90deg);
    }
    100% {
        transform: rotate(90deg);
    }
`;

const pulseAnimation = keyframes`
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
`;

const RotateDeviceIndicator: React.FC<RotateDeviceIndicatorProps> = ({ show = true }) => {
    const [isPortrait, setIsPortrait] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkOrientation = () => {
            const portrait = window.matchMedia('(orientation: portrait)').matches;
            const mobile = window.innerWidth < 900;
            setIsPortrait(portrait);
            setIsMobile(mobile);
        };

        checkOrientation();
        window.addEventListener('resize', checkOrientation);
        window.addEventListener('orientationchange', checkOrientation);

        return () => {
            window.removeEventListener('resize', checkOrientation);
            window.removeEventListener('orientationchange', checkOrientation);
        };
    }, []);

    // Only show if enabled, on mobile, and in portrait mode
    if (!show || !isMobile || !isPortrait) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 60,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 9999,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                borderRadius: '12px',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                backdropFilter: 'blur(8px)',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                animation: `${pulseAnimation} 2s ease-in-out infinite`,
            }}
        >
            <PhoneIphoneIcon 
                sx={{ 
                    color: 'white',
                    fontSize: 28,
                    animation: `${rotateAnimation} 3s ease-in-out infinite`,
                }} 
            />
            <ScreenRotationIcon 
                sx={{ 
                    color: 'white',
                    fontSize: 24,
                }} 
            />
        </Box>
    );
};

export default RotateDeviceIndicator;
